import * as React from "react"
import { useEffect } from "react"
import { Alert, Grid } from "@mui/material"

import { MANAGEMENT_ROUTES } from "@constants"
import { customerID, customerSelectedID, isSystemBusy } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import {
    ManagementPricingConfigModeChangeWarning,
    ManagementPricingConfigModeSelect,
    ManagementPricingConfigSaveBar
} from "./@components"
import { MODE_BY_SETUP, PRICING_CONFIG_MODES } from "./@constants"
import { usePricingConfigSetup } from "./@hooks"
import {
    customerSetup,
    isConfigEmpty,
    modeChangeAcknowledged,
    pricingConfigMode,
    resetManagementPricingConfigSignals
} from "./@signals"
import ManagementPricingConfigFilters from "./Filters"
import ManagementPricingConfigRetailer from "./Retailer"
import ManagementPricingConfigRrsp from "./Rrsp"


export default function ManagementPricingConfigPage() {

    const { isLoading } = usePricingConfigSetup()

    useEffect(() => resetManagementPricingConfigSignals, [])

    const props = {
        head: `${MANAGEMENT_ROUTES.TITLE} | ${MANAGEMENT_ROUTES.PRICING_CONFIG_TITLE}`,
        title: MANAGEMENT_ROUTES.PRICING_CONFIG_TITLE,
        subtitle: MANAGEMENT_ROUTES.PRICING_CONFIG_SUBTITLE,
        isEmpty: isConfigEmpty.value,
        actions: null,
        filters: <ManagementPricingConfigFilters />,
        hasErrors: isSystemBusy.value
    }

    // The customer selector only exists for customer 0, so for anyone else the page has no input at
    // all. Say why instead of showing an empty screen — the v2 endpoints would answer 403 anyway.
    if (customerID.value !== 0)
        return <PageWrapper {...props} filters={null}>
            <Alert severity="warning" variant="outlined">
                This form configures other customers, so it is only available to the internal
                customer.
            </Alert>
        </PageWrapper>

    // While the chosen mode differs from what the customer *is*, the branch stays closed: editing
    // rows of a type it does not have yet reads as if the switch had already happened.
    const currentMode = MODE_BY_SETUP[customerSetup.value?.mode]
    const isModeChangePending = !!currentMode
        && currentMode !== pricingConfigMode.value
        && !modeChangeAcknowledged.value

    return <PageWrapper {...props}>
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <ManagementPricingConfigModeSelect isLoading={isLoading} />
            </Grid>

            <Grid item xs={12}>
                <ManagementPricingConfigModeChangeWarning />
            </Grid>

            <Grid item xs={12}>
                <ManagementPricingConfigSaveBar />
            </Grid>

            {!customerSelectedID.value && <Grid item xs={12}>
                <Alert severity="info" variant="outlined">
                    Select a customer to see how its reference price is configured.
                </Alert>
            </Grid>}

            {!!customerSelectedID.value && !isModeChangePending && <Grid item xs={12}>
                {pricingConfigMode.value === PRICING_CONFIG_MODES.RRSP
                    ? <ManagementPricingConfigRrsp />
                    : <ManagementPricingConfigRetailer />}
            </Grid>}

        </Grid>
    </PageWrapper>
}
